import { t } from "../../../utilities/translator";

const getAgencyProperties = () => {
  const user = JSON.parse(localStorage.getItem('hf_user') || '{}');
  if (user.userContextMetaData?.b2bDisplayProperties) {
    return user.userContextMetaData.b2bDisplayProperties;
  }

  return null;
}

const AgentCommissionLabel = () => {
  const agencyProperties = getAgencyProperties();

  if (!agencyProperties?.displayCommissionOnSite || window.location.href.indexOf('b2bcustomerview=true') > -1) {
    return null;
  }

  return (
    <div className="text-primary text-xs font-medium">{t('dealItem.agentCommission', { value: agencyProperties.commissionPer })}</div>
  )
}

export default AgentCommissionLabel
